import React from 'react';
const Costituzione_società = () => {
    return (
        <>            
            <table cellpadding="3" cellspacing="0">
                <tbody>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="3">Elenco Documenti Atto Costitutivo di Società per il Notaio da&nbsp;persone fisiche</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Carta d’identità o patente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Tesserino del codice fiscale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Autorizzazione giudiziale</td>
                        <td valign="top">Per rappresentanza di incapaci</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Permesso di soggiorno</td>
                        <td valign="top">Per extracomunitari</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="4">Elenco Documenti Atto Costitutivo di Società per il Notaio da&nbsp;enti e società</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">documento d’identità del legale rappresentante</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">certificato camerale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">statuto vigente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">libro verbali con delibera firmata</td>
                        <td valign="top">Per enti con consiglio di amministrazione</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="5">Elenco Documenti Atto Costitutivo di Società per il Notaio inerenti la struttura della società</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Versamento 2,5 decimi</td>
                        <td valign="top">Se capitale versato in denaro</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Versamento 10 decimi</td>
                        <td valign="top">Se unico socio</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Perizia di stima</td>
                        <td valign="top">Se conferimento diverso da denaro</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">- Titolo di acquisto
                        - Certificato catastale e planimetria con confini
                        - Abilitazioni edilizie comunali rilasciate dal 1967 in avanti (licenze, concessioni, autorizzazioni, d.i.a., permessi di costruire, pratiche di condono, licenze di abitabilità)</td>
                        <td valign="top">Se conferimento di immobile</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Certificato di destinazione urbanistica</td>
                        <td valign="top">Se conferimento di terreno</td>
                    </tr>
                </tbody>
            </table>
        </>
        );
    }

export default Costituzione_società;